import moment from 'moment';
import { fieldNames } from '../../config';

export const compareToStartDate = (entity) => (_rule, value, callback) => {
  const startDate =
    typeof entity.getFieldValue === 'function'
      ? entity.getFieldValue(fieldNames.startDate)
      : moment(entity.startDate);

  const hasValidVal = moment.isMoment(value);
  const hasValidStartDate = moment.isMoment(startDate);

  if (
    hasValidVal &&
    hasValidStartDate &&
    value.isSameOrBefore(startDate, 'minute')
  ) {
    callback(
      'Дата и время не могут быть установлены ранее даты и времени начала отключения'
    );
  } else {
    callback();
  }
};

export const validateToEndAndPlanEndDate =
  (form) => (_rule, value, callback) => {
    if (value) {
      const { planEndDate, endDate } = form.getFieldsValue([
        fieldNames.planEndDate,
        fieldNames.endDate,
      ]);

      const validateFieldNames = [
        Boolean(planEndDate) && fieldNames.planEndDate,
        Boolean(endDate) && fieldNames.endDate,
      ].filter(Boolean);

      form.validateFields(validateFieldNames, { force: true });
    }

    callback();
  };
